import 'leaflet';
import BasePopup from '../../../../utils/map/popup/BasePopup.js'
import Vue from 'vue'
import MapRelationUpdate from '../../components/map-relation-update.vue'

const MapRelation = BasePopup.extend({
  getVueComponent: function () {
    return new Vue(MapRelationUpdate)
  }
})

export default MapRelation
